import React from 'react'
import samsungPayRequest from 'utils/samsungPayRequest'
import { recordCountlyEvent } from 'utils'

export default class SamsungPay extends React.Component {
  state = { isReady: false }
  buttonContainerId = 'samsung-pay-button-container'

  handleClick = () => {
    const { payMethod, submit, orderToken } = this.props
    const orderNumber = this.props.orderNumber || this.props.siteConfig?.orderNo
    const total = this.props.total || this.props.siteConfig?.payInfo?.payAmount?.amount
    const merchantName = this.props.merchantName || this.props.siteConfig?.merchantName || 'PayBy Merchant'
    const currency = this.props.currency || this.props.siteConfig?.payInfo?.payAmount?.currency || 'AED'
    const countryCode = this.props.countryCode || this.props.siteConfig?.countryCode || 'AE'

    if (!orderNumber || !total) {
      // Show error to user (e.g., toast, modal, etc)
      console.error('Order number and amount are required for Samsung Pay')
      return
    }
    recordCountlyEvent({
      page_name: 'cashier',
      element_name: 'pay',
      event_name: 'submit',
      biz_tags: {
        trade_voucher_no: orderNumber,
        token: orderToken,
        pay_method: 'samsung_pay',
      },
    })
    samsungPayRequest.loadPaymentSheet({
      orderNumber,
      total,
      merchantName,
      currency,
      countryCode,
      onResult: (paymentCredential, error) => {
        if (error) {
          console.error('Samsung Pay payment failed:', error)
        } else {
          console.log('Samsung Pay payment succeeded:', paymentCredential)
          submit({
            method: 'PAY_WITH_DEVICE',
            devicePayInfo: {
              paymentToken: JSON.stringify(paymentCredential),
              decryptType: 'MERCHANT_DECRYPT',
              cardNoSuffix: paymentCredential.card_last4digits,
              cardBrand: paymentCredential.card_brand,
            },
            payMethodShortNo: payMethod?.payMethodShortNo,
          })
        }
      },
    })
  }

  componentDidMount = () => {
    // Dynamically load the Samsung Pay SDK script if not already loaded
    if (!window.SamsungPay || !window.SamsungPay.PaymentClient) {
      const scriptId = 'samsungpay-sdk'
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script')
        script.id = scriptId
        script.src = 'https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js'
        script.onload = this.checkReady
        document.body.appendChild(script)
      } else {
        document.getElementById(scriptId).onload = this.checkReady
      }
    } else {
      this.checkReady()
    }
  }

  checkReady = async () => {
    const isReady = await samsungPayRequest.isReadyToPay()
    this.setState({ isReady }, () => {
      if (isReady) this.createSamsungPayButton()
    })
  }

  createSamsungPayButton = () => {
    const container = document.getElementById(this.buttonContainerId)
    if (container) {
      container.innerHTML = ''
      const btn = samsungPayRequest.createButton({
        onClick: this.handleClick,
        buttonStyle: 'white',
      })
      if (btn) {
        container.appendChild(btn)
      }
    }
  }

  render() {
    if (!this.state.isReady) return null
    return (
      <React.Fragment>
        <div id={this.buttonContainerId} style={{ width: '100%', height: 48 }} />
        <style>
          {`
            #${this.buttonContainerId} > button {
              width: 100%;
              height: 48px;
              border-radius: 8px !important;
              color: #000 !important;
              border: 1px solid #000 !important;
              background-size: 30% !important;
            }
          `}
        </style>
      </React.Fragment>
    )
  }
}
